module.exports = __webpack_public_path__ + "static/media/TASK 1 if-wrong.f38ab0d4.mp3";